
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        sectors: {
            type: Array as PropType<{ id: number; sectorName: string }[]>,
            default: () => []
        }
    }
})
